var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2016_16837",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2016_16837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3555 18.7998C9.97776 18.7998 9.66109 18.6721 9.40553 18.4165C9.14998 18.1609 9.0222 17.8443 9.0222 17.4665C9.0222 17.0887 9.14998 16.7721 9.40553 16.5165C9.66109 16.2609 9.97776 16.1332 10.3555 16.1332C10.7333 16.1332 11.05 16.2609 11.3055 16.5165C11.5611 16.7721 11.6889 17.0887 11.6889 17.4665C11.6889 17.8443 11.5611 18.1609 11.3055 18.4165C11.05 18.6721 10.7333 18.7998 10.3555 18.7998ZM16.0667 18.7998C15.6889 18.7998 15.3722 18.6721 15.1167 18.4165C14.8611 18.1609 14.7333 17.8443 14.7333 17.4665C14.7333 17.0887 14.8611 16.7721 15.1167 16.5165C15.3722 16.2609 15.6889 16.1332 16.0667 16.1332C16.4444 16.1332 16.7611 16.2609 17.0167 16.5165C17.2722 16.7721 17.4 17.0887 17.4 17.4665C17.4 17.8443 17.2722 18.1609 17.0167 18.4165C16.7611 18.6721 16.4444 18.7998 16.0667 18.7998ZM21.6222 18.7998C21.2445 18.7998 20.9278 18.6721 20.6722 18.4165C20.4167 18.1609 20.2889 17.8443 20.2889 17.4665C20.2889 17.0887 20.4167 16.7721 20.6722 16.5165C20.9278 16.2609 21.2445 16.1332 21.6222 16.1332C22 16.1332 22.3167 16.2609 22.5722 16.5165C22.8278 16.7721 22.9556 17.0887 22.9556 17.4665C22.9556 17.8443 22.8278 18.1609 22.5722 18.4165C22.3167 18.6721 22 18.7998 21.6222 18.7998ZM6.2222 29.3332C5.6222 29.3332 5.10183 29.1128 4.6611 28.6721C4.22037 28.2313 4 27.711 4 27.111V7.11094C4 6.51094 4.22037 5.99057 4.6611 5.54984C5.10183 5.10908 5.6222 4.8887 6.2222 4.8887H8.1111V2.6665H10.4444V4.8887H21.5556V2.6665H23.8889V4.8887H25.7778C26.3778 4.8887 26.8982 5.10908 27.3389 5.54984C27.7796 5.99057 28 6.51094 28 7.11094V27.111C28 27.711 27.7796 28.2313 27.3389 28.6721C26.8982 29.1128 26.3778 29.3332 25.7778 29.3332H6.2222ZM6.2222 27.111H25.7778V13.1109H6.2222V27.111ZM6.2222 10.8887H25.7778V7.11094H6.2222V10.8887Z",
    fill: "#054BC7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.dc04c4c448780bf9216e26d0a7bd32d9.svg";
export { ForwardRef as ReactComponent };